import {Component, Input, OnInit} from '@angular/core';
import {GAService} from "../../root/ga/ga.service";
import {MobileService} from "../../core/mobile.service";
import {BookingService} from "./booking.service";
import {NotificationService} from "../../root/toast/notification.service";
import {SessionService} from "../../core/session.service";

@Component({
    selector: 'email-tooltip',
    templateUrl: './email-tooltip.component.html',
    providers: [GAService, BookingService,MobileService]
})
export class EmailTooltipComponent implements OnInit {

    @Input() bookingOid: Number;
    @Input() companyOid: Number;
    @Input() gaValue: string;

    constructor(private gaService: GAService, private mobileService: MobileService,
                private bookingService: BookingService, private toast: NotificationService,
                private session:SessionService) {
    }

    companyMail:string = "";
    clientMail:string = "";
    bookingMap: Map<Number,string> = new Map();
    isDisable:boolean;
    isMobile:boolean = this.mobileService.isMobile();
    oneTimeTooltip:boolean = true;

    ngOnInit() {
       if(!this.session.getUserSession()){
            this.session.getSubject().subscribe((message) => {
                if(!!message.done){
                    this.isButtonDisabled();
                }
            });
        }else{
            this.isButtonDisabled();
        }
    }

    ngAfterContentChecked(){
        const someButtons:any = document.getElementsByName("contact-button");
        const someCopyButtons:any = document.getElementsByName("copy-button");
        const someTooltipsPosition:any = document.getElementsByName("tooltip-position");

        if(this.mobileService.isMobile()){
            for (let item of someButtons) {
                item.classList.add("-lg");
            }

            for(let item of someCopyButtons){
                item.classList.add("-lg");
            }

            for(let item of someTooltipsPosition){
                item.classList.add("-top");
            }
        }
        else{
            for (let item of someButtons) {
                item.classList.add("-sm");
            }

            for(let item of someCopyButtons){
                item.classList.add("-sm");
            }

            for(let item of someTooltipsPosition){
                item.classList.add("-bottom");
                item.classList.add("pull-right");
            }
        }
    }


    hiddingInfoTooltip(){
       const infoTooltip = document.getElementById("info-tooltip");
        if (infoTooltip) {
            infoTooltip.classList.remove('-show-tooltip');
        }
    }

    isButtonDisabled() {
        const hasCompanyPerm = this.session.loggedUserAllowed('PERM_USER_TYPE_COMPANY');
        const hasContactPerm = this.session.loggedUserAllowed('PERM_BOOKING_START_CONVERSATION');

        this.isDisable = !hasCompanyPerm && !hasContactPerm;
    }

    sendGa(arg) {
        this.gaService.notify("Autos_Mensajeria", this.gaValue, [arg]);
    }

    toggleTooltip(e: Event, bookingOid: Number, shouldShow?: boolean) {
        e.stopPropagation();
        this.hiddingInfoTooltip();

        const buttonLoader = document.getElementById("buttonLoader-" + bookingOid);
        const tooltipElem = document.getElementById("tooltipMail-" + bookingOid);
        const greenElement = document.getElementById('greenElement-' + bookingOid);
        const copyButton = document.getElementById('copiedMail-' + bookingOid);

        if (shouldShow) {
            this.sendGa('Abrir_Tooltip');
            const someTooltip:any = document.getElementsByClassName('-show-tooltip');
            for (let someTooltipKey of someTooltip) {
                someTooltipKey.classList.remove("-show-tooltip");
            }
            buttonLoader.classList.add("-loading");
        } else {
            tooltipElem.classList.remove("-show-tooltip");
            greenElement.classList.remove('copied-display');
            copyButton.classList.remove('-eva-3-hide');
            greenElement.classList.add("-eva-3-hide");
            this.sendGa('Cerrar_Tooltip');
        }
    }

    copyMail(bookingOid: Number) {
        const copyButton = document.getElementById('copiedMail-' + bookingOid);
        let el = document.getElementById('eva-input-mail-' + bookingOid);
        let greenElement = document.getElementById('greenElement-' + bookingOid);
        el.focus();
        document.execCommand('selectAll');
        document.execCommand('copy');
        el.blur();

        copyButton.classList.add('-eva-3-hide');
        greenElement.classList.add("copied-display");
        greenElement.classList.remove("-eva-3-hide");

        setTimeout(function() {
            greenElement.classList.remove('copied-display');
            copyButton.classList.remove('-eva-3-hide');
            greenElement.classList.add("-eva-3-hide");
        }, 3000);

        this.sendGa('Copiar_Email');
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/booking/email-tooltip.component.ts